import { useEffect } from "react";
import { motion } from "framer-motion";
import { EASE } from "./shared";
import { LogoMark } from "./LogoMark";

const LETTERS = ["C", "L", "A", "R", "K", "E"];

export const Preloader = ({ onComplete }) => {
    useEffect(() => {
        const t = setTimeout(onComplete, 2100);
        return () => clearTimeout(t);
    }, [onComplete]);

    return (
        <motion.div
            data-testid="preloader"
            className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-ink"
            exit={{ y: "-100%" }}
            transition={{ duration: 0.9, ease: EASE }}
        >
            <motion.div
                initial={{ opacity: 0, scale: 0.92 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.9, ease: EASE }}
                className="mb-10"
            >
                <LogoMark className="h-16 w-16 md:h-20 md:w-20" />
            </motion.div>
            <div className="flex overflow-hidden">
                {LETTERS.map((l, i) => (
                    <motion.span
                        key={i}
                        className="font-display text-5xl font-medium tracking-[0.08em] text-bone md:text-7xl"
                        initial={{ y: "110%" }}
                        animate={{ y: "0%" }}
                        transition={{ duration: 0.9, ease: EASE, delay: 0.15 + i * 0.07 }}
                    >
                        {l}
                    </motion.span>
                ))}
            </div>
            <motion.p
                className="mt-4 text-[10px] uppercase tracking-[0.5em] text-gold md:text-xs"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.8, delay: 0.9 }}
            >
                Business Solutions
            </motion.p>
            <motion.div
                className="mt-8 h-px w-40 origin-left bg-gold/60"
                initial={{ scaleX: 0 }}
                animate={{ scaleX: 1 }}
                transition={{ duration: 1.4, ease: EASE, delay: 0.5 }}
            />
        </motion.div>
    );
};
